export const _webpMimeTypes = ["image/webp"];
